import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import useAuthUtils from "../../../../../../../hooks/auth/useAuthUtils";
import usePyqRedux from "./usePyqRedux";
import { url_268 } from "../../../../../../../custom_utilities/api_services";

export const useGetTabsList = () => {
  const { headers, startLoading, finishLoading, targetId } = useAuthUtils();
  const { setPyqMainCurrentTab, setPyqSubCurrentTab } = usePyqRedux();

  const fetchTabs = async () => {
    try {
      startLoading();
      const response = await axios.get(url_268, headers);

      if (response.data.status === 200) {
        const pyq = response?.data?.data?.pyq;

        setPyqMainCurrentTab(pyq?.data?.[0]);
        setPyqSubCurrentTab(pyq?.data?.[0]?.pyqSubList?.[0]);

        return pyq ?? {};
      }

      return {};
    } catch (err) {
      console.error("fetchTabs failed:", err);
      return {};
    } finally {
      finishLoading();
    }
  };

  return useQuery({
    queryKey: ["pyq-tabs", targetId],
    queryFn: fetchTabs,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
};
